import { X } from "lucide-react";

type ReplyPreviewBarProps = {
  authorName: string;
  content: string;
  onDismiss: () => void;
};

function stripHtmlForPreview(html: string): string {
  if (typeof document === "undefined") return html;
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export function ReplyPreviewBar({
  authorName,
  content,
  onDismiss,
}: ReplyPreviewBarProps) {
  const plainContent = stripHtmlForPreview(content);

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-muted/30 border-t border-border">
      <div className="w-0.5 h-8 bg-primary rounded-full flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-foreground truncate">
          {authorName}
        </p>
        <p className="text-xs text-muted-foreground line-clamp-1">
          {plainContent}
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="flex-shrink-0 p-1 rounded-full hover:bg-muted transition-colors"
        aria-label="Dismiss reply"
      >
        <X className="h-4 w-4 text-muted-foreground" />
      </button>
    </div>
  );
}
